// extracted by mini-css-extract-plugin
export var cardIcon = "_52-4";
export var checkboxCard = "_52-0";
export var checkboxCardSelected = "_52-1";
export var disabled = "_52-2";
export var outerBorder = "_52-3";
export var spacerMedium = "_52-7";
export var spacerSmall = "_52-6";
export var spacerXsmall = "_52-5";